import { Static, Type } from "@sinclair/typebox";

export const LeadStatus = Type.Object({
  MasterLabel: Type.String(),
  ApiName: Type.String(),
  SortOrder: Type.Number(),
  IsConverted: Type.Boolean(),
  Id: Type.String(),
  SubStatuses: Type.Optional(Type.Array(Type.Any())),
});

export type LeadStatusType = Static<typeof LeadStatus>;
